import { QueryHookOptions, gql, useQuery } from '@apollo/client'
import { PromotedProductCampaignQuery, PromotedProductCampaignQueryVariables } from 'types/graphql'

const query = gql`
  query PromotedProductCampaign($brandId: ID!) {
    brand(id: $brandId) {
      id
      promotedProductCampaign {
        id
        title
        imageFullPath
      }
    }
  }
`

export const usePromotedProductCampaign = (options?: QueryHookOptions<PromotedProductCampaignQuery, PromotedProductCampaignQueryVariables>) => {
  return useQuery<PromotedProductCampaignQuery, PromotedProductCampaignQueryVariables>(query, options)
}
